import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SummerNoteConfig } from 'src/app/common/summernote-config';
import { WebsiteConfigrationService } from '../../services/website/website-configration.service';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { MatDialog } from '@angular/material/dialog';
import { extractErrorMessage } from 'src/app/core/services/uitls/error.util';

@Component({
    selector: 'app-service-seo',
    templateUrl: './service-seo.component.html',
    styleUrl: './service-seo.component.scss',
    standalone: false
})
export class ServiceSeoComponent implements OnInit {

  summerNoteConfig = SummerNoteConfig.MAIN_CONFIG;
  submitted: boolean = false;
  serviceId: string = '';
  errorMsg: boolean = false;
  message: string = '';
  saveDialogRef: any;

  dialog = inject(MatDialog);
  route = inject(ActivatedRoute);
  websiteConfigrationService = inject(WebsiteConfigrationService);

  seoConfigFormGroup: FormGroup = new FormGroup({
    slug: new FormControl(
      '',
      [
        Validators.required,
        Validators.maxLength(80),
        Validators.pattern('^[\u0600-\u06FFa-z0-9-]+$') // Arabic letters, numbers, and hyphens only
      ]
    ),
    meta_title: new FormControl(''),
    meta_description: new FormControl('')
  });

  ngOnInit(): void {
    this.serviceId = this.route.snapshot.params.id;
    this.getSEOData();
    this.seoConfigFormGroup.statusChanges.subscribe(status => {
      if (status === 'VALID' && this.submitted) {
        this.errorMsg = false;
      }
    });
  }

  getSEOData() {
    this.websiteConfigrationService.getSEODataByServiceID(this.serviceId).subscribe({
      next: (res) => {
        this.seoConfigFormGroup.patchValue({
          slug: res.slug,
          meta_title: res.meta_title,
          meta_description: res.meta_description
        });
      },
      error: (err) => {
        console.error('Error fetching SEO data:', err);
      }
    });
  }

  save(event) {
    this.submitted = true;
    this.errorMsg = false;
    if (this.seoConfigFormGroup.invalid) {
      this.errorMsg = true;
      this.message = 'برجاء تعبئة  جميع الخانات ';
      this.seoConfigFormGroup.markAllAsTouched();
      return;
    }
    const payload = this.seoConfigFormGroup.value;
    this.updateServiceSEOConfiguration(payload, event.buttonId);
  }

  updateServiceSEOConfiguration(payload, buttonId) {
    this.websiteConfigrationService.updateSEODataByServiceID(this.serviceId, payload, buttonId).subscribe({
      next: (res) => {
        this.message = 'تم تحديث البيانات بنجاح';
        this.showAlertBox(true, this.message);
      },
      error: (error) => {
        this.message = extractErrorMessage(error);
        this.showAlertBox(false, this.message);
      }
    });
  }

  showAlertBox(successImg, confirmMsg) {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: successImg,
        message: confirmMsg,
        button: 'تم',
        isBack: successImg
      },
    });
  }
}
